import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { SEO } from '../components/SEO';
import { Home, ArrowLeft, Search } from 'lucide-react';

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-dark flex flex-col">
      <SEO
        title="404 - ไม่พบหน้าที่คุณค้นหา"
        description="ขอโทษค่ะ หน้าที่คุณกำลังมองหาไม่มีอยู่หรืออาจถูกย้ายไปแล้ว กลับไปหน้าหลักหรือสำรวจบริการของเรา"
        robots="noindex, nofollow"
      />
      
      <Header />
      
      <main className="flex-1 flex items-center justify-center px-6 py-24">
        <div className="max-w-2xl w-full text-center space-y-8">
          {/* 404 Number with gradient */}
          <div className="relative">
            <h1 className="text-[120px] md:text-[180px] font-bold leading-none bg-gradient-to-r from-neon-purple via-neon-pink to-neon-cyan bg-clip-text text-transparent opacity-20 select-none">
              404
            </h1>
            <div className="absolute inset-0 flex items-center justify-center">
              <Search className="w-16 h-16 md:w-24 md:h-24 text-neon-cyan/30" strokeWidth={1.5} />
            </div>
          </div>

          {/* Error Message */}
          <div className="space-y-4">
            <h2 className="text-3xl md:text-4xl font-bold text-text-primary font-heading">
              {t('notFound.title', 'ไม่พบหน้าที่คุณค้นหา')}
            </h2>
            <p className="text-lg text-text-secondary max-w-md mx-auto">
              {t('notFound.description', 'ขอโทษค่ะ หน้าที่คุณกำลังมองหาไม่มีอยู่หรืออาจถูกย้ายไปแล้ว')}
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-8">
            <Link
              to="/"
              className="btn-primary group inline-flex items-center gap-2 px-8 py-4"
            >
              <Home className="w-5 h-5" />
              <span>{t('notFound.backHome', 'กลับหน้าหลัก')}</span>
            </Link>
            
            <button
              onClick={() => window.history.back()}
              className="btn-secondary group inline-flex items-center gap-2 px-8 py-4"
            >
              <ArrowLeft className="w-5 h-5" />
              <span>{t('notFound.goBack', 'ย้อนกลับ')}</span>
            </button>
          </div>

          {/* Helpful Links */}
          <div className="pt-12 border-t border-white/10">
            <p className="text-text-muted mb-4">
              {t('notFound.helpfulLinks', 'หน้าที่น่าสนใจ')}
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <Link
                to="/#services"
                className="text-neon-cyan hover:text-neon-cyan/80 transition-colors"
              >
                {t('notFound.services', 'บริการของเรา')}
              </Link>
              <span className="text-white/20">•</span>
              <Link
                to="/portfolio"
                className="text-neon-cyan hover:text-neon-cyan/80 transition-colors"
              >
                {t('notFound.portfolio', 'ผลงาน')}
              </Link>
              <span className="text-white/20">•</span>
              <Link
                to="/contact"
                className="text-neon-cyan hover:text-neon-cyan/80 transition-colors"
              >
                {t('notFound.contact', 'ติดต่อเรา')}
              </Link>
            </div>
          </div>

          {/* Decorative Orbs */}
          <div className="orb absolute top-1/4 left-1/4 w-72 h-72 bg-neon-purple/10 rounded-full blur-3xl -z-10" />
          <div className="orb absolute bottom-1/4 right-1/4 w-96 h-96 bg-neon-cyan/10 rounded-full blur-3xl -z-10" />
        </div>
      </main>
      
      <Footer />
    </div>
  );
}
